"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var is_equal_1 = require("./is-equal");
// 浅比对的 key
var ignoreKeys = ["dataSource", "chartRef", "tips"];
function comparePropsEqual(prev, next, compareKeys) {
    var e_1, _a;
    var keys = compareKeys || Object.keys(prev).concat(Object.keys(next));
    try {
        for (var keys_1 = tslib_1.__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            if (!ignoreKeys.includes(key)) {
                if (!is_equal_1.isDeepEqual(prev[key], next[key])) {
                    return false;
                }
            }
            if (prev[key] !== next[key])
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
exports.comparePropsEqual = comparePropsEqual;
//# sourceMappingURL=compare-props-equal.js.map